import Socket from './Socket'

export default new Socket()